var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5104 10.9896C33.8299 14.3091 33.8299 19.691 30.5104 23.0104C27.191 26.3299 21.8091 26.3299 18.4896 23.0104C15.1701 19.691 15.1701 14.3091 18.4896 10.9896C21.8091 7.67014 27.191 7.67014 30.5104 10.9896",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 40.5C8.5 35.53 12.53 31.5 17.5 31.5H22.666",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.498 42.5H33.056L39.912 35.644C40.694 34.862 40.694 33.596 39.912 32.816L38.184 31.088C37.402 30.306 36.136 30.306 35.356 31.088L28.5 37.942L28.498 42.5V42.5Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageAccount);
export default __webpack_public_path__ + "static/media/manageAccount.c2d184babd2960d7cab0125478943946.svg";
export { ForwardRef as ReactComponent };